import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { IconButton } from '@mui/material';
import { Box, keyframes } from '@mui/system';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 20px 20px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

interface IconButtonWhatsAppProps {
  phone: string;
  message?: string;
}

export function IconButtonWhatsApp({
  phone,
  message,
}: IconButtonWhatsAppProps): JSX.Element {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(
    message || 'Olá, Preciso de auxílio!',
  )}`;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        width: { xs: 60, sm: 80 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: { xs: 40, sm: 50 },
          height: { xs: 40, sm: 50 },
          bgcolor: 'rgba(37, 211, 102, 0.5)',
          borderRadius: '50%',
          transform: {
            xs: 'translate(-150%, -50%)',
            sm: 'translate(-280%, -50%)',
          },
          animation: `${pulse} 1.9s infinite`,
          zIndex: 0,
        }}
      />
      <IconButton
        onClick={() => window.open(url, '_blank')}
        sx={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          width: { xs: 40, sm: 50 },
          height: { xs: 40, sm: 50 },
          bgcolor: '#25D366',
          color: '#fff',
          zIndex: 1,
          transform: {
            xs: 'translate(-150%, -50%)',
            sm: 'translate(-280%, -50%)',
          },
        }}
      >
        {React.createElement(FaWhatsapp as any, { size: { xs: 20, sm: 28 } })}
      </IconButton>
    </Box>
  );
}
